<template>
  <div class="sttingPage">
    <div class="warehousingPage">
      <template v-if="state == 1">
        <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
          <van-swipe-item v-for="(item, index) in bannerList" :key="index"
            ><van-image width="100%" fit="scale-down" :src="item"
          /></van-swipe-item>
        </van-swipe>
        <div class="formDate">
          <div class="item">
            <div class="tit">变动原因</div>
            <div class="input_box flex-between" @click="handleShowPopup(10)">
              <van-field
                v-model="actreasonValue"
                placeholder="选择变动原因"
                readonly
              />
              <i class="iconfont icon-bottom"></i>
            </div>
          </div>
          <div class="item">
            <div class="tit">入库数量</div>
            <div class="input_box">
              <van-field
                type="number"
                v-model="formData.num"
                placeholder="输入入库数量"
                maxlength="10"
              />
            </div>
          </div>
          <!-- <div class="item">
            <div class="tit">入库订单信息记录</div>
            <div class="input_box">
              <van-field
                v-model="formData.purchaseno"
                placeholder="输入入库订单信息"
                maxlength="50"
              />
            </div>
          </div> -->
          <!-- <div class="item">
            <div class="tit">入库收货物流类型</div>
            <div class="input_box flex-between" @click="handleShowPopup(5)">
              <van-field
                v-model="formData.wsid"
                placeholder="选择记录入库收货物流类型"
                readonly
              />
              <i class="iconfont icon-bottom"></i>
            </div>
          </div> -->
          <!-- <div class="item">
            <div class="tit">入库收货物流单号记录</div>
            <div class="input_box scan">
              <van-field
                v-model="formData.wsno"
                placeholder="选择记录入库收货物流单号"
                maxlength="50"
              />
            </div>
          </div> -->
          <div class="item">
            <div class="tit">备注信息记录</div>
            <div class="textarea_box">
              <van-field
                type="textarea"
                v-model="formData.reason"
                placeholder="填写备注（200字以内）"
                maxlength="200"
              />
            </div>
          </div>
          <div class="item">
            <div class="tit">入库位置</div>
            <div
              class="select_box flex-between margin_b"
              @click="handleShowPopup(1)"
            >
              <van-field v-model="whname1" placeholder="选择仓库" readonly />
              <i class="iconfont icon-bottom"></i>
            </div>
            <div
              class="select_box flex-between margin_b"
              @click="handleShowPopup(2)"
            >
              <van-field v-model="whname2" placeholder="选择货架" readonly />
              <i class="iconfont icon-bottom"></i>
            </div>
            <div
              class="select_box flex-between margin_b"
              @click="handleShowPopup(3)"
            >
              <van-field v-model="whname3" placeholder="选择层号" readonly />
              <i class="iconfont icon-bottom"></i>
            </div>
            <div class="input_box flex-between" @click="handleShowPopup(4)">
              <van-field v-model="whname4" placeholder="选择位置" readonly />
              <i class="iconfont icon-bottom"></i>
            </div>
          </div>
          <div class="item">
            <div class="tit">入库商品属性参数记录</div>
            <div
              class="item_block"
              v-for="(item, index) in detail.attr"
              :key="index"
            >
              <span>{{ item.attrname }}：</span>
              <div
                class="select_box flex-between"
                @click="handleShowPopup(11, item, index)"
              >
                <van-field
                  v-model="selectAttrArr[index]"
                  placeholder="选择属性标签"
                  readonly
                />
                <i class="iconfont icon-bottom"></i>
              </div>
            </div>
            <!-- <div
              class="select_box flex-between margin_b"
              @click="handleShowPopup(6)"
            >
              <van-field
                v-model="attrLabel"
                placeholder="选择属性标签"
                readonly
              />
              <i class="iconfont icon-bottom"></i>
            </div>
            <div class="input_box flex-between" @click="handleShowPopup(7)">
              <van-field
                v-model="attrValue"
                placeholder="选择属性值"
                readonly
              />
              <i class="iconfont icon-bottom"></i>
            </div> -->
          </div>
          <div class="item">
            <div class="tit">入库商品批次记录</div>
            <div class="input_box">
              <van-field
                v-model="formData.makerno"
                placeholder="输入商品批次记录"
              />
            </div>
          </div>
          <div class="item">
            <div class="tit">入库商品生产商</div>
            <div class="select_box flex-between" @click="handleShowPopup(9)">
              <van-field
                v-model="supplierName"
                placeholder="选择商品生产商"
                readonly
              />
              <i class="iconfont icon-bottom"></i>
            </div>
          </div>
        </div>
        <div class="">
          <!-- <div class="return-fixd"> -->
          <div class="primary-button" @click="handleSubmit">提交确认</div>
          <!-- <div class="default-button return" @click="handleReturn">←返回</div> -->
          <div class="primary-button return" @click="handleReturn">
            <i class="iconfont icon-yuyinjiantou"></i>返回
          </div>
        </div>
      </template>
      <template v-if="state == 2">
        <div class="confirmationInfo">
          <div class="tit">信息确认</div>
          <div class="goods_desciption">
            <p class="txt1 fontSize-blueColor-xll">
              商品ID：{{ formData.cmid }}
            </p>
            <p class="txt2 fontSize-blueColor-xll">商品名称：</p>
            <p class="txt3">{{ detail.commodityname }}</p>
            <p class="txt3">{{ detail.commodityname_e }}</p>
            <p class="txt3">{{ detail.commodityname_y }}</p>
            <p class="txt3">{{ detail.commodityname_m }}</p>
            <p class="txt3">{{ detail.commodityname_t }}</p>
            <p class="txt1 fontSize-blueColor-xll">
              SKU采购编码：{{ detail.sku }}
            </p>
            <p class="fontSize-blueColor-xll">ISBN编码： {{ detail.ISBN }}</p>
          </div>
          <div class="goods_other_desciption">
            <div class="good_item">
              <h3>变动原因：</h3>
              <p>{{ actreasonValue }}</p>
            </div>
            <div class="good_item">
              <h3>入库数量：</h3>
              <p>{{ formData.num }}</p>
            </div>
            <!-- <div class="good_item">
              <h3>入库订单信息记录：</h3>
              <p>（采购订单）{{ formData.purchaseno }}</p>
            </div>
            <div class="good_item">
              <h3>入库收货物流类型记录：</h3>
              <p>{{ formData.wsid }}</p>
            </div>
            <div class="good_item">
              <h3>入库收货物流单号记录：</h3>
              <p>{{ formData.wsno }}</p>
            </div> -->
            <div class="good_item">
              <h3>备注信息记录：</h3>
              <p>{{ formData.reason }}</p>
            </div>
            <div class="good_item">
              <h3>入库位置：</h3>
              <p v-if="whname1">{{ whname1 }}，</p>
              <p v-if="whname2">{{ whname2 }}，</p>
              <p v-if="whname3">{{ whname3 }}，</p>
              <p v-if="whname4">{{ whname4 }}，</p>
            </div>
            <div class="good_item">
              <h3>入库商品属性参数记录：</h3>
              <p>{{ formData.attr }}</p>
            </div>
            <div class="good_item">
              <h3>入库商品批次记录：</h3>
              <p>{{ formData.makerno }}</p>
            </div>
            <div class="good_item">
              <h3>入库商品生产商记录：</h3>
              <p>{{ supplierName }}</p>
            </div>
            <div class="good_item">
              <h3>操作日期：</h3>
              <p>{{ nowDate }}</p>
              <!-- <p>2023-1-23 09:16:36</p> -->
            </div>
            <div class="good_item">
              <h3>操作人员：</h3>
              <p>{{ formData.userman }}</p>
            </div>
          </div>
        </div>

        <div class="return">
          <div class="primary-button" @click="queryBtn">确认</div>
          <!-- <div class="default-button return" @click="handleReturn1">←返回</div> -->
          <div class="primary-button return" @click="handleReturn1">
            <i class="iconfont icon-yuyinjiantou"></i>返回
          </div>
        </div>
      </template>

      <template v-if="state == 3">
        <div class="resultPage">
          <h1>操作成功</h1>
          <!-- <div class="primary-button" @click="handleReturn">←返回业务中心</div> -->
          <div class="primary-button return" @click="handleReturn">
            <i class="iconfont icon-yuyinjiantou"></i>返回
          </div>
        </div>
      </template>
    </div>

    <van-popup v-model="isShow" position="bottom" :style="{ height: '40%' }">
      <template v-if="popupType == 1">
        <van-picker
          title="请选择仓库"
          show-toolbar
          :columns="warehouseOne"
          @confirm="onConfirm"
          @cancel="isShow = false"
          value-key="whname"
        />
      </template>
      <template v-if="popupType == 2">
        <van-picker
          title="请选择货层"
          show-toolbar
          :columns="warehouseTwo"
          @confirm="onConfirm"
          @cancel="isShow = false"
          value-key="whname"
        />
      </template>
      <template v-if="popupType == 3">
        <van-picker
          title="请选择层号"
          show-toolbar
          :columns="warehouseThree"
          @confirm="onConfirm"
          @cancel="isShow = false"
          value-key="whname"
        />
      </template>
      <template v-if="popupType == 4">
        <van-picker
          title="请选择位置"
          show-toolbar
          :columns="warehouseFour"
          @confirm="onConfirm"
          @cancel="isShow = false"
          value-key="whname"
        />
      </template>
      <template v-if="popupType == 5">
        <van-picker
          title="请选择物流类型"
          show-toolbar
          :columns="logisiticsList"
          @confirm="onConfirm"
          @cancel="isShow = false"
        />
      </template>
      <template v-if="popupType == 6">
        <van-picker
          title="请选择属性标签"
          show-toolbar
          :columns="attrLabelList"
          @confirm="onConfirm"
          @cancel="isShow = false"
          value-key="attrname"
        />
      </template>
      <template v-if="popupType == 7">
        <van-picker
          title="请选择属性值"
          show-toolbar
          :columns="attrValueList"
          @confirm="onConfirm"
          @cancel="isShow = false"
          value-key="attrvalue"
        />
      </template>
      <template v-if="popupType == 8">
        <van-picker
          title="请选择记录类型"
          show-toolbar
          :columns="actnameList"
          @confirm="onConfirm"
          @cancel="isShow = false"
        />
      </template>
      <template v-if="popupType == 9">
        <van-picker
          title="请选择生产商"
          show-toolbar
          :columns="supplierList"
          @confirm="onConfirm"
          @cancel="isShow = false"
        />
      </template>
      <template v-if="popupType == 10">
        <van-picker
          title="请选择变动原因"
          show-toolbar
          :columns="actreasonList"
          @confirm="onConfirm"
          value-key="reason"
          @cancel="isShow = false"
        />
      </template>
      <template v-if="popupType == 11">
        <van-picker
          title="请选择属性标签"
          show-toolbar
          :columns="attrColumn"
          @confirm="onConfirm"
          value-key="attrvalue"
          @cancel="isShow = false"
        />
      </template>
    </van-popup>
  </div>
</template>

<script>
import {
  getCommidityDetail,
  setShopWareParam,
  getWearhouseList,
  getProducerList,
  getLogistics,
  getAttrLabelList,
  getAttrLabelValue,
  encryptstringview,
} from "../../api/api";
import { getShopBasenumReason } from "../../api/shop";
import { mapState } from "vuex";
export default {
  name: "wManageSettingItem",
  data() {
    return {
      state: 1,
      isShowStyle: false,
      tabbarActive: 0,
      qyid: 0,
      nowDate: "",

      detail: "", // 商品详情

      isShow: false,
      columns: ["杭州", "宁波", "温州", "绍兴", "湖州", "嘉兴", "金华", "衢州"],
      // 记录类型
      actname: "",
      actnameList: [
        {
          text: "增加",
          value: "add",
        },
        {
          text: "减少",
          value: "reduce",
        },
      ],

      popupType: 1,

      bannerList: "", // 商品banner
      warehouseList: [],

      warehouseOne: [], // 仓库
      whname1: "",
      warehouseOneChild: [],
      warehouseTwo: [], // 货架
      whname2: "",
      warehouseTwoChild: [],
      warehouseThree: [], // 层数
      whname3: "",
      warehouseThreeChild: [],
      warehouseFour: [], // 位置
      whname4: "",

      // 生产商
      supplierName: "",
      supplierList: [],

      // 物流
      logisiticsList: [],

      // 属性标签
      attrLabelList: [],
      attrLabel: "",
      // 属性值
      attrValueList: [],
      attrValue: "",

      // 仓库变动原因
      actreasonList: [],
      actreasonValue: "",

      attrColumn: [], // 商品的属性标签

      type: 1, // 1采购入库 2生产入库
      formData: {
        Method: "ams_shop_commodity_basenumadd",
        cmid: "",
        realnum: "", // 实际库存数
        actname: "", // 记录类型 add增加 reduce减少
        actreasonid: "", // 变动原因id 从接口246获取reasonid
        num: "", // 数量
        reason: "", // 备注
        whid1: "", // 接口224仓库id
        whid2: "", // 接口224货架id
        whid3: "", // 接口224层位id
        whid4: "", // 接口224货位id

        userman: "", // 登录的管理员名
        // ams_shop_commodity_attrid: "", // 属性标签id 从接口235获取
        // ams_shop_commodity_attr_value: "", // 属性值id 从接口236获取
        attr: [], // 多组属性标签
        purchaseno: "", // 采购订单号
        wsid: "", // 物流类型 从接口237获取
        wsogid: "", // 物流商品id 默认跟cmid一样
        makerno: "", // 商品批次
        makername: "", // 生厂商id 从接口234的生厂商字段(supplier)里获取
        wsno: "", // 物流单号
      },

      selectAttrIndex: "", // 当前下拉选择的attr
      selectAttrArr: [],
    };
  },
  computed: {
    // shopItem
    ...mapState(["OPENID"]),
  },
  created() {
    let { routerList, USERINFO } = this.$store.state;
    let { name } = this.$route;
    if (USERINFO.qy) {
      this.qyid = USERINFO.qy.id;
    } else {
      this.qyid = 0;
    }
    this.formData.userman = USERINFO.truename;

    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, this.OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { id, type } = JSON.parse(res.jsondata);
        this.formData.cmid = id;
        this.formData.wsogid = id;
        this.formData.actname = type;
        this.getInit();
      } else {
        this.$router.back();
      }
    },

    async getInit() {
      await this.getDetail();
      // await this.getWarehouse();
      // await this.getLogisitics();
      // await this.getAttrLabel();
    },

    // 获取商品详情
    getDetail() {
      let { cmid } = this.formData;
      const toast = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      getCommidityDetail({ id: cmid }).then((res) => {
        let bannerList = [];
        bannerList.push(res.banner);
        bannerList.push(res.banner2);
        bannerList.push(res.banner3);
        bannerList.push(res.banner4);
        bannerList.push(res.banner5);
        let filter = bannerList.filter((v) => v != "");
        this.bannerList = filter;
        this.detail = res;
        toast.clear();
      });
    },

    // 获取货架
    getWarehouse() {
      const Toast = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      getWearhouseList({
        openid: this.$store.state.OPENID,
        qyid: this.qyid,
      }).then((res) => {
        if (res.length > 0) {
          this.warehouseOne = res;
        } else {
          this.warehouseOne = [];
        }

        Toast.clear();
      });
    },

    handleShowPopup(type, item, index) {
      let { warehouseOne, warehouseTwo, warehouseThree, attrLabel } = this;
      this.popupType = type;
      if (type == 1) {
        this.getWarehouse();
        this.isShow = true;
      } else if (type == 2) {
        if (warehouseOne.length == 0) {
          this.$toast("请选择仓库");
          return;
        }
        if (warehouseTwo.length == 0) {
          this.$toast("暂无货架");
          return;
        }
        this.isShow = true;
      } else if (type == 3) {
        if (warehouseTwo.length == 0) {
          this.$toast("请选择仓库或货架");
          return;
        }
        this.isShow = true;
      } else if (type == 4) {
        if (warehouseThree.length == 0) {
          this.$toast("请选择仓库或货架或层号");
          return;
        }
        this.isShow = true;
      } else if (type == 5) {
        this.isShow = true;
      } else if (type == 6) {
        this.getAttrLabel();
        this.isShow = true;
      } else if (type == 7) {
        if (attrLabel == "") {
          this.$toast("请选择属性标签");
          return;
        }
        this.isShow = true;
      } else if (type == 8) {
        this.isShow = true;
      } else if (type == 9) {
        this.getSupplier();
        this.isShow = true;
      } else if (type == 10) {
        this.getShopBasenumReason();
        this.isShow = true;
      } else if (type == 11) {
        console.log(item, "==========");
        this.selectAttrIndex = index;
        this.attrColumn = item.items;
        this.isShow = true;
      }
    },
    // 获取生产商
    getSupplier() {
      let { qyid } = this;
      const Toast = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      getProducerList({ qyid, Page: 1, PageSize: 100 }).then((res) => {
        let newDate = [];
        res.forEach((v) => {
          newDate.push({
            value: v.id,
            text: v.labelname,
          });
        });
        this.supplierList = newDate;
        Toast.clear();
      });
    },

    // 获取物流类型
    getLogisitics() {
      const Toast = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      getLogistics().then((res) => {
        let newData = [];
        res.forEach((v) => {
          newData.push({
            text: v.etext,
            value: v.evalue,
          });
        });
        this.logisiticsList = newData;
        Toast.clear();
      });
    },

    // 获取属性标签
    getAttrLabel() {
      const Toast = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      getAttrLabelList().then((res) => {
        let newArr = [
          {
            attrname: "无",
            id: 0,
          },
        ];
        let filterArr = res.filter((v) => v.attrstate == "启用");
        this.attrLabelList = newArr.concat(filterArr);
        Toast.clear();
      });
    },
    // 获取属性值
    getAttrValue(attrid) {
      const Toast = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      let { cmid } = this.formData;
      getAttrLabelValue({ attrid, cmid }).then((res) => {
        let newArr = [
          {
            attrvalue: "无",
            id: 0,
          },
        ];
        let filterArr = res.filter((v) => v.isuse);
        this.attrValueList = newArr.concat(filterArr);
        Toast.clear();
      });
    },

    // 获取仓库变动原因
    getShopBasenumReason() {
      let type = this.formData.actname;
      getShopBasenumReason().then((res) => {
        // reasontype - add、reduce
        let filterArr = res.filter((v) => v.reasontype === type);
        this.actreasonList = filterArr;
      });
    },

    // 确认弹窗
    onConfirm(e) {
      if (e == undefined) {
        this.isShow = false;
        return;
      }
      let { popupType, selectAttrIndex, detail } = this;
      let { value, text } = e;
      if (popupType == 1) {
        this.formData.whid1 = e.id;
        this.whname1 = e.whname;
        this.warehouseTwo = e.childs2;

        this.formData.whid2 = "";
        this.whname2 = "";
        this.warehouseThree = [];
        this.formData.whid3 = "";
        this.whname3 = "";
        this.warehouseFour = [];
        this.formData.whid4 = "";
        this.whname4 = "";
      } else if (popupType == 2) {
        this.formData.whid2 = e.id;
        this.whname2 = e.whname;
        this.warehouseThree = e.childs3;

        this.formData.whid3 = "";
        this.whname3 = "";
        this.warehouseFour = [];
        this.formData.whid4 = "";
        this.whname4 = "";
      } else if (popupType == 3) {
        this.formData.whid3 = e.id;
        this.whname3 = e.whname;
        this.warehouseFour = e.childs4;

        this.formData.whid4 = "";
        this.whname4 = "";
      } else if (popupType == 4) {
        this.formData.whid4 = e.id;
        this.whname4 = e.whname;
      } else if (popupType == 5) {
        this.formData.wsid = value;
      } else if (popupType == 6) {
        this.formData.ams_shop_commodity_attrid = e.id;
        this.attrLabel = e.attrname;
        this.getAttrValue(e.id);
        this.formData.ams_shop_commodity_attr_value = "";
        this.attrValue = "";
        this.formData.attr = [];
      } else if (popupType == 7) {
        this.formData.ams_shop_commodity_attr_value = e.id;
        this.attrValue = e.attrvalue;
        this.formData.attr = JSON.stringify([
          this.attrLabel + "；" + e.attrvalue,
        ]);
      } else if (popupType == 8) {
        this.formData.actname = value;
        this.actname = text;
      } else if (popupType == 9) {
        this.formData.makername = value;
        this.supplierName = text;
      } else if (popupType == 10) {
        this.formData.actreasonid = e.reasonid;
        this.actreasonValue = e.reason;
      } else if (popupType == 11) {
        console.log(e, "---===0");
        this.selectAttrArr[selectAttrIndex] = e.attrvalue;
        this.formData.attr[selectAttrIndex] =
          detail.attr[selectAttrIndex].attrname + "；" + e.attrvalue;
      }
      this.isShow = false;
      console.log(this.formData);
    },

    handleReturn() {
      this.$router.go(-1);
    },

    handleReturn1() {
      this.state = 1;
    },
    handleSubmit() {
      let { formData, detail } = this;
      if (formData.num == "") {
        this.$toast("请输入入库数量");
        return;
      }
      if (formData.attr.length < detail.attr.length) {
        this.$toast("请选择全部属性标签值");
        return;
      }
      // if (formData.purchaseno == "") {
      //   this.$toast("请输入入库订单信息");
      //   return;
      // }
      // if (formData.wsno == "") {
      //   this.$toast("请输入入库收货物流单号");
      //   return;
      // }
      let time = new Date();
      let year = time.getFullYear();
      let month = time.getMonth() + 1;
      let date = time.getDate();
      let h = time.getHours();
      let m = time.getMinutes();
      let s = time.getSeconds();
      this.nowDate =
        year + "-" + month + "-" + date + " " + h + ":" + m + ":" + s;
      this.state = 2;
    },
    queryBtn() {
      let { formData } = this;
      this.$toast.loading({
        message: "提交中...",
        forbidClick: true,
      });
      // if (formData.ams_shop_commodity_attrid == 0) {
      //   this.formData.ams_shop_commodity_attrid = "";
      //   this.formData.ams_shop_commodity_attr_value = "";
      //   this.formData.attr = "";
      // }
      formData.attr = JSON.stringify(formData.attr);
      setShopWareParam(formData).then((res) => {
        if (res.result) {
          setTimeout(() => {
            this.$toast.success(res.message);
          }, 2000);
          setTimeout(() => {
            this.state = 3;
          }, 3500);
        } else {
          this.$toast.fail(res.message);
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.warehousingPage {
  padding-bottom: 380px;
  .my-swipe {
    height: 750px;
    background: #f8f8f8;
  }
  .van-cell {
    padding: 0;
    width: 100%;
    height: 100%;
    /deep/ .van-field__body {
      height: 100%;
    }
  }
  .formDate {
    padding: 117px 75px;
    .item {
      margin-bottom: 45px;
      .item_block {
        margin-bottom: 25px;
        span {
          font-size: 28px;
          margin-bottom: 15px;
          display: inline-block;
        }
        &:last-child {
          margin-bottom: 0;
        }
      }
      .tit {
        font-size: 30px;
        color: #444444;
        margin-bottom: 28px;
        text-align: center;
      }
      .textarea_box {
        .van-cell {
          padding: 10px 0;
          /deep/ .van-field__control {
            height: 100%;
          }
        }
      }
    }
  }
  .confirmationInfo {
    padding: 108px 64px 148px;
    .tit {
      font-size: 50px;
      color: #444444;
      text-align: center;
      margin-bottom: 100px;
    }
  }
  .goods_desciption .txt3 {
    font-size: 32px;
  }
  .confirmationInfo {
    padding: 108px 64px 148px;
    .tit {
      font-size: 50px;
      color: #444444;
      text-align: center;
      margin-bottom: 100px;
    }
  }
  .resultPage {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 35%;
    h1 {
      font-weight: 400;
      font-size: 50px;
      margin-bottom: 140px;
      text-align: center;
      white-space: nowrap;
    }
  }
}
</style>